import FullSlide from './FullSlide'
import FormSlide from './FormSlide'
import { Col, Row } from 'react-bootstrap'

const experienceData = {
  languages: [
    'Solidity',
    'DevOps',
    'JavaScript',
    'React',
    'Typescript',
    'Vyper',
    'Python',
    'C++'
  ],
  experienceLevels: ['No experience', 'Familiar', 'Proficient']
}

const roleFormData = experienceData.languages.map(lang => {
  const children = [
    {
      text: lang,
      type: 'text',
      className: 'h5',
      as: Col
    },
    ...experienceData.experienceLevels.map((eL, idx) => ({
      label: lang,
      type: 'radio-inline',
      // defaultChecked: idx === 0,
      name: lang,
      value: eL,
      errorHandling: { required: 'required' }
    }))
  ]
  return {
    type: 'parent',
    Parent: Row,
    className: 'mb-3 align-items-center role-table',
    children
  }
})

const RoleSlide = props => {
  return (
    <FormSlide
      SlideLayout={FullSlide}
      id='role-slide'
      step={5}
      totalSteps={5}
      stageName='Finding your place at Aragon'
      formData={roleFormData}
      defaultValData={experienceData.languages.map(lang => ({ label: lang }))}
      rightContentHeader={
        <>
          <h4 className='font-weight-bold mb-5'>
            Please indicate your knowledge/experience in each of the following:
          </h4>
          <Row className='mb-3 role-table'>
            <Col></Col>
            {experienceData.experienceLevels.map((eL, idx) => (
              <Col className='text-center h5' key={idx}>
                {eL}
              </Col>
            ))}
          </Row>
        </>
      }
      {...props}
    />
  )
}

export default RoleSlide
